import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const ConfigService = {
  getConfig: () => {
    return axios.get(`${API_BASE_URL}/config`);
  },

  updateConfig: (config: any) => {
    return axios.post(`${API_BASE_URL}/config`, config);
  },

  getExternalAIModels: () => {
    return axios.get(`${API_BASE_URL}/config/external-ai-models`);
  },

  testExternalAI: (base_url: string, api_key: string, model: string) => {
    return axios.post(`${API_BASE_URL}/config/test-external-ai`, { base_url, api_key, model });
  },

  uploadGmailCredentials: (file: File) => {
    const formData = new FormData();
    formData.append('credentials', file);
    return axios.post(`${API_BASE_URL}/config/gmail-credentials`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};